import { datadogRum } from '@datadog/browser-rum';
import { reactPlugin } from '@datadog/browser-rum-react';
import useUser from '@hooks/auth/useUser';
import { ReactNode, useEffect } from 'react';

interface Props {
    children?: ReactNode;
}

function DatadogProvider({ children }:Props) {
    const { user } = useUser();
    useEffect(() => {
        if (import.meta.env.MODE !== 'development') {
            datadogRum.init({
                applicationId: import.meta.env.VITE_DATADOG_APPLICATION_ID,
                clientToken: import.meta.env.VITE_DATADOG_CLIENT_TOKEN,
                site: 'datadoghq.com',
                service: import.meta.env.VITE_DATADOG_SERVICE_NAME,
                env: import.meta.env.VITE_DATADOG_ENVIRONMENT,
                sessionSampleRate: 100,
                sessionReplaySampleRate: 100,
                defaultPrivacyLevel: 'mask-user-input',
                allowedTracingUrls: [
                    import.meta.env.VITE_API_URL,
                    (url) => url.startsWith(import.meta.env.VITE_API_URL)],
                plugins: [reactPlugin({ router: false })],
                trackResources: true,
                trackLongTasks: true,
                trackUserInteractions: true,
            });
        }
    }, []);
    useEffect(() => {
        if (import.meta.env.MODE !== 'development') {
            if (user) {
                datadogRum.setUser({
                    name: user.nickname,
                    id: user.barcodeNo,
                });
            } else {
                datadogRum.clearUser();
            }
        }
    }, [user]);
    return children;
}

export default DatadogProvider;
